import { h } from 'preact';
import { makeText } from '../../../util';

export const StackTitle = ({ stack, selected, toggleStack, language, settings, dev }) => {

  const counts = { active: 0, rejected: 0 };
  stack.categories.forEach(c => {
    if (selected === 'consent' && c.active) {
      counts.active += 1;
    } else if (selected === 'consent' && !c.active) {
      counts.rejected += 1;
    }
    if (selected === 'li' && c.legInt) {
      counts.active += 1;
    } else if (selected === 'li' && !c.legInt) {
      counts.rejected += 1;
    }
  });

  let actualStatus = 'partial';
  if (counts.active > 0 && counts.rejected === 0) actualStatus = 'accepted';
  if (counts.rejected > 0 && counts.active === 0) actualStatus = 'rejected';

  let actualColor = settings.toggleOffColor;
  if (actualStatus === 'accepted') actualColor = settings.toggleColor;
  if (actualStatus === 'partial') actualColor = settings.toggleNeutralColor;

  const statusFont = { ...settings.accordionsFont };
  delete statusFont.color;
  const toggleValue = actualStatus === 'accepted' ? false : true;

  const toggleOnText = makeText(Boolean(dev), settings, 'toggleOnText', language);
  const toggleOffText = makeText(Boolean(dev), settings, 'toggleOffText', language);
  const hasText = toggleOnText || toggleOffText;
  const hasTextClass = hasText ? ' has-text' : '';
  const basicClassName = actualStatus === 'accepted' ? (' pm-switch checked' + hasTextClass) : (' pm-switch' + hasTextClass);

  const toggle = (e) => toggleStack(e, stack.categories, toggleValue, selected === 'li');
  return (
    <div className="stack-title">
      <h4 style={{ ...settings.accordionsFont }}>{stack.name}</h4>
      <label
        className={'pm-nswitch ' + actualStatus + basicClassName}
        onKeyDown={e => e.keyCode == 13 && toggle(e)}
      >
        <span
          tabIndex="0"
          className={actualStatus === 'accepted' ? 'slider round is-checked' : 'slider round'}
          style={{ backgroundColor: actualColor }}
          onClick={toggle}
        >{ actualStatus === 'partial' ? null : (actualStatus === 'accepted' ? toggleOnText : toggleOffText) }</span>
      </label>
    </div>
  );
};